import { c as _c } from "react/compiler-runtime";
import { Box, Stack } from "@mui-wrapper";
import { MarkupMoreTagsChip, MarkupTagChip } from "@pages/project-details/project-markups/markup-tags";
import { sortMarkupTags } from "@pages/project-details/project-markups/markup-tags-sort";

/** Number of tags shown as chips in a board card, the rest are counted in a single chip */
const DEFAULT_MAX_VISIBLE_TAGS = 2;
/** Single row with the first tags of a markup as chips, followed by the amount of the rest */
export function MarkupsBoardTags(t0) {
  const $ = _c(16);
  const {
    tags,
    maxVisibleTags: t1
  } = t0;
  const maxVisibleTags = t1 === undefined ? DEFAULT_MAX_VISIBLE_TAGS : t1;
  let T0;
  let hiddenTags;
  let t2;
  let t3;
  let t4;
  if ($[0] !== maxVisibleTags || $[1] !== tags) {
    const sortedTags = sortMarkupTags(tags);
    hiddenTags = sortedTags.slice(maxVisibleTags);
    T0 = Stack;
    t2 = "row";
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        gap: 0.5,
        minWidth: 0
      };
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t4 = sortedTags.slice(0, maxVisibleTags).map(_temp);
    $[0] = maxVisibleTags;
    $[1] = tags;
    $[2] = T0;
    $[3] = hiddenTags;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    T0 = $[2];
    hiddenTags = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[8] !== hiddenTags) {
    t5 = hiddenTags.length > 0 && <Box sx={{
      display: "flex",
      flexShrink: 0
    }}><MarkupMoreTagsChip tags={hiddenTags} /></Box>;
    $[8] = hiddenTags;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== T0 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <T0 direction={t2} sx={t3}>{t4}{t5}</T0>;
    $[10] = T0;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp(tag) {
  return <MarkupTagChip key={tag.id} tag={tag} />;
}